import React, { useState } from 'react';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import { useUserInfo } from '@repository/auth/useUserInfo';
import DotChart from './dotChart';
import DotChartInfo from './dotChartInfo';
import QuestionGuides from './questionGuides';
import CompetencyInnerCard from '../common/competencyInnerCard';
import CompetencyCard from '../common/competencyCard';
import classnames from 'classnames/bind';
import styles from './jobRecommend.module.scss';

const cx = classnames.bind(styles);

const dotChartTooltipContent = (
  <>
    <p>앞서 분석한 응시자님의 역량유형과 역량 프로파일에 잘 맞는 직군을 추천해드려요.</p>
    <p>오른쪽에 표시되어 있을수록 역량유형에 잘 맞는 직군이고 위쪽에 표시되어 있을수록 역량에 잘 맞는 직군이에요.</p>
    <p>역량유형에도 잘 맞고 역량프로파일에도 잘 맞는 직군이라면 응시자님에게 추천하는 직군이라고 할 수 있어요!</p>
    <p>직군을 클릭하여 직군 안에 어떤 세무 직무가 있는지도 확인해보세요.</p>
  </>
);

const questionGuidesTooltipContent = (
  <>
    <p>
      응시자님에게 가장 잘 맞는 추천 직군에 대해서 실무 면접과 인성 면접을 대비할 수 있는 질문과 가이드를 제공합니다.
    </p>
  </>
);

const JobRecommend = () => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const { data: userInfo } = useUserInfo();
  const userName = userInfo?.name ?? '회원';
  const { accaResultStore } = useResultStore();
  const { accJobCuration } = accaResultStore;

  if (!accJobCuration) return null;

  const { jobRankings, bestJobGroup } = accJobCuration;

  if (!jobRankings) return null;

  const typeRank = jobRankings[activeIndex]?.typeRank;
  const competenceRank = jobRankings[activeIndex]?.competenceRank;

  const getRecommend = () => {
    if (typeRank <= 5 && competenceRank <= 6) return 'recommend';
    if (typeRank >= 6 && competenceRank >= 7) return 'notRecommend';
    return 'common';
  };

  return (
    <CompetencyCard title={`${userName}님에게 잘 어울리는 직군/직무 추천`} cardType={'gray'} iconType={'job'}>
      <div className={cx('wrap')}>
        {/* [D] 한 눈에 보는 직군 영역 */}
        <CompetencyInnerCard
          title={'한 눈에 보는 직군'}
          subTitle={'직군을 클릭하시면 상세한 직군/직무 설명을 볼 수 있어요.'}
          tooltipContent={dotChartTooltipContent}
        >
          <div>
            {/* [D] 점 차트 영역 */}
            <div className={cx('dotChartWrap')}>
              <DotChart activeIndex={activeIndex} setActiveIndex={setActiveIndex} />
            </div>

            {/* [D] 점 차트 설명 영역 */}
            <div className={cx('dotChartInfoWrap')}>
              <DotChartInfo activeIndex={activeIndex} recommend={getRecommend()} />
            </div>
          </div>
        </CompetencyInnerCard>

        {/* [D] 나에게 맞는 BEST 직군은? 영역 */}
        <CompetencyInnerCard
          title={'나에게 맞는 BEST 직군은?'}
          jobTitle={bestJobGroup.name}
          subTitle={'나에게 잘 맞는 직군의 예상 면접 질문과 가이드를 얻어 가세요.'}
          tooltipContent={questionGuidesTooltipContent}
        >
          <QuestionGuides />
        </CompetencyInnerCard>

        <p className={cx('noticeText')}>
          나에게 맞는 BEST 직군에서 제공되는 면접 질문과 가이드는 실제 기업 채용에서 제시되는 내용과 구성이 다를 수
          있습니다.
        </p>
      </div>
    </CompetencyCard>
  );
};

export default JobRecommend;
